import {requests} from "../../helpers/api.services";
import {NEWS_URL} from "../../helpers/api.routes";

export const InFocusSettingsService = {
    get: () => requests.get(`${NEWS_URL}/in-focus/settings`),
    update: (payload: FormData) => requests.post(`${NEWS_URL}/in-focus/settings`, payload, true),
    delete: () => requests.delete(`${NEWS_URL}/in-focus/settings`)
}